module.exports = __webpack_public_path__ + "media/images/flags/ms-83a17b118ab7d9a19762ee4a07bcf20f.svg";